// ------------------------------------------------------------------------------------
// 複数動画の際にラジオボタンで動画が選択されていなければ受講ボタンをdisabledにする処理
export default () => {
  const multiLessonRadioBtnBlock = document.getElementById('multi-lesson-radio-buttons-block');
  if (!multiLessonRadioBtnBlock) return;

  const attendBtn = document.getElementById('attendance-start-button');
  const lessonRadioBtns = Array.from(document.getElementsByClassName('lesson-choice'));

  // 初回実行
  window.addEventListener('load', () => {
    lessonRadioBtns.forEach((lessonRadioBtn) => {
      attendBtn.disabled = !lessonRadioBtn.checked;
    });
  });

  // ラジオボタンを押された時
  lessonRadioBtns.forEach((lessonRadioBtn) => {
    lessonRadioBtn.addEventListener('change', () => {
      attendBtn.disabled = !lessonRadioBtn.checked;
    });
  });
};
